import React, { Component } from "react";
import axios from "axios";
import _ from "lodash";
import { Link } from "react-router-dom";
import TestimonialBlock from "./TestimonialBlock";
import edge from "../assets/edge.svg";

class Testimonials extends Component {
  constructor() {
    super();
    this.state = {
      data: null
    };
  }
  componentDidMount() {
    const SITE_URL = "https://oncourse.dev-ggmm.com";

    axios.get(SITE_URL + "/wp-json/wp/v2/testimonials").then(res => {
      this.setState(
        {
          data: res.data
          //   pageTitle: res.data[0].title.rendered,
          //   seo: res.data[0].yoast_meta,
          //   pageContent: res.data[0].content.rendered,
          //   sectionTitle: res.data[0].acf.team_section_headline,
          //   featuredImage: res.data[0].better_featured_image.source_url
        },
        () => window.scrollTo(0, 0)
      );
    });
  }

  render() {
    const { data } = this.state;
    if (data) {
      return (
        <div className="testimonials bg-gray">
          <img className="edge" src={edge} alt="Edge Element" />
          <div className="inner max-width">
            <div className="left-blurb">
              <h2>What our clients are saying</h2>
              <p>
                From Fortune 500 companies to a wide variety of small
                businesses, we strive to make working with us as smooth as
                possible.
              </p>
              <Link to="/applications" className="btn main">
                Applications
              </Link>
            </div>
            <div className="testimonial-feed">
              {_.map(data, (block, i) => {
                if (i <= 1) {
                  return <TestimonialBlock key={i} data={block} />;
                }
              })}
            </div>
          </div>
        </div>
      );
    } else return false;
  }
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/Testimonials.js